import React,{ useContext, useState } from "react";
import { EComponentName } from "../common/enum/EComponentName";
import SnackbarContext from "./Context/SnackbarContext";

const SnackBarContextProvider = (props) => {
    const [msg, setMsg] = useState("");
    const [name, setName] = useState<any>(EComponentName.NotMentioned);
    const [isDisplayed, setIsDisplayed] = useState(false);
    const displayHandler = (msg, name) => {
        setMsg(msg);
        setIsDisplayed(true);
        setName(name);        
    };

    const closeHandler = () => {
        setIsDisplayed(false);
        setName(EComponentName.NotMentioned);   
        setMsg("");
    };
    return (
        <SnackbarContext.Provider
            value={{
                name,
                msg,
                isDisplayed,
                displayMsg: displayHandler,
                onClose: closeHandler,
            }}
        >
            {props.children}
        </SnackbarContext.Provider>
    );
};

export default SnackBarContextProvider;


export const useSnackbar = () => {
    return useContext(SnackbarContext)
  }